import script from "./GestioneSensoreRh.vue?vue&type=script&setup=true&lang=js"
export * from "./GestioneSensoreRh.vue?vue&type=script&setup=true&lang=js"

import "./GestioneSensoreRh.vue?vue&type=style&index=0&id=cd4c4150&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd4c4150"]])

export default __exports__